/**
 * Desc: 返回顶部
 */

import styles from './goTop.scss';
import React  from 'react';
import cns from 'classnames';
import { BackTop } from 'antd';

export default function GoTop({ className, ...others }) {
    return (
        <BackTop {...others} className={cns(styles.goTop, className)}>
            <i className="iconfont icon-arrow-up"> </i>
        </BackTop>
    );
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/common/goTop/GoTop.jsx